export default "__VITE_ASSET__mTtXrRGs__"